import { Box, Text, Button,Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";

import { BiLogoGmail } from "react-icons/bi";
import {
  IconPhone,
  IconMail,
  IconBrandFacebook,
  IconBrandLinkedin,
  IconMenu2,
  IconMapPin,
  IconBrandInstagram,
  IconChevronDown,
  IconBrandGmail,
} from "@tabler/icons-react";
import { Link } from "react-router-dom";
const MotionBox = motion(Box);

export const HeroSection = () => {
  return (
    <Box
  position="relative"
  height={{ base: "100vh", md: "100vh" }}
  overflow="hidden"
>
  {/* Background Video */}
   {/* <Box display={{ base: "none", md: "block" }}>
    <video
      src="/home.mp4"
      autoPlay
      loop
      muted
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        filter: "brightness(0.6)",
      }}
    />
  </Box> */}


 <Box
    display={{ base: "block", }}
    bgImage="url('/mobilebaner.png')"  // apna mobile banner image path yaha do
    bgSize="cover"
    bgPos="center"
    width="100%"
    height="100%"
    filter="brightness(0.6)"
  />

  {/* Overlay Content (Centered Text & Button) */}
  <Box
    position="absolute"
    top="0"
    left="0"
    width="100%"
    height="100%"
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="left"
    textAlign="left"
    px={20}
  >
    {/* <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
      <Text color="white" fontSize={{ base: "3xl", md: "5xl" }} fontWeight="bold">
        Where Service Meets
      </Text>
    </motion.div> */}

    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.3 }}>
      <Text color="white" fontSize={{ base: "3xl", md: "5xl" }} fontWeight="bold" mb={0}>
        Experience Service, 
      </Text>
      <Text color="white" fontSize={{ base: "3xl", md: "5xl" }} fontWeight="bold"mb={2} >
        Experience Excellence
    
      </Text>

                  <Box width="100px" height="4px" bg="#B67300" mb={2}  />
              

               <Text color="white" fontSize={{ base: "md", md: "xl" }} fontWeight="bold"mb={2} >
        Reliable Building Services From Demolition to Cleaning
    
      </Text>
    </motion.div>

    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.6 }}>
      <Button
        bg="#B67300"
        color="white"
        px={8}
        py={3}
        borderRadius="md"
        // _hover={{ bg: "#d84a1a" }}
         as={Link}
  to="/contact"
      >
        Contact Us
      </Button>
    </motion.div>
  </Box>

  {/* Right Side Social Icons */}
  <Flex
    position="fixed"
    right="20px"
    top="50%"
    transform="translateY(-50%)"
    flexDirection="column"
    gap={3}
    zIndex={10}
  >
    {[
 { Icon: BiLogoGmail, link: "mailto:info@lionsforgecontracting.ca" },

  { Icon: IconBrandInstagram, link: "https://www.instagram.com/lionsforgecontracting?igsh=MTF5dTM4MDNlMG9xdA%3D%3D&utm_source=qr"},
  { Icon: IconBrandLinkedin, link: "https://www.linkedin.com/company/lionsforgecontracting/" }
].map(({Icon, link},i) => (
      <Box
       as="a"
      href={link}
        key={i}
        bg="#B67300"
        p={2}
        borderRadius="full"
        cursor="pointer"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Icon size={30} color="white" />
      </Box>
    ))}

     <MotionBox
    as="a"
    href="tel:+1 (604) 712-5656"
    bg="#B67300"
    borderRadius="full"
    p={3}
    boxShadow="lg"
    // whileHover={{ scale: 1.2 }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="white"
      viewBox="0 0 24 24"
      width="20"
      height="20"
    >
      <path d="M6.62 10.79a15.53 15.53 0 006.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.56 0 1.01.45 1.01 1.01v3.5c0 .56-.45 1.01-1.01 1.01C10.61 21.03 2.97 13.39 2.97 4.01c0-.56.45-1.01 1.01-1.01h3.5c.56 0 1.01.45 1.01 1.01 0 1.24.2 2.45.57 3.57.12.35.03.74-.24 1.02l-2.2 2.2z" />
    </svg>
  </MotionBox>
  </Flex>
</Box>

  );
};
